var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H2C0.875 0 0 0.90625 0 2V12C0 13.125 0.875 14 2 14H12C13.0938 14 14 13.125 14 12V2C14 0.90625 13.0938 0 12 0ZM13 12C13 12.5625 12.5312 13 12 13H2C1.4375 13 1 12.5625 1 12V2C1 1.46875 1.4375 1 2 1H12C12.5312 1 13 1.46875 13 2V12ZM4 3.25C3.5625 3.25 3.25 3.59375 3.25 4C3.25 4.4375 3.5625 4.75 4 4.75C4.40625 4.75 4.75 4.4375 4.75 4C4.75 3.59375 4.40625 3.25 4 3.25ZM7 6.25C6.5625 6.25 6.25 6.59375 6.25 7C6.25 7.4375 6.5625 7.75 7 7.75C7.40625 7.75 7.75 7.4375 7.75 7C7.75 6.59375 7.40625 6.25 7 6.25ZM4 9.25C3.5625 9.25 3.25 9.59375 3.25 10C3.25 10.4375 3.5625 10.75 4 10.75C4.40625 10.75 4.75 10.4375 4.75 10C4.75 9.59375 4.40625 9.25 4 9.25ZM10 3.25C9.5625 3.25 9.25 3.59375 9.25 4C9.25 4.4375 9.5625 4.75 10 4.75C10.4062 4.75 10.75 4.4375 10.75 4C10.75 3.59375 10.4062 3.25 10 3.25ZM10 9.25C9.5625 9.25 9.25 9.59375 9.25 10C9.25 10.4375 9.5625 10.75 10 10.75C10.4062 10.75 10.75 10.4375 10.75 10C10.75 9.59375 10.4062 9.25 10 9.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.7c91847b.svg";
export { ForwardRef as ReactComponent };